import { Redirect, type RouteProps, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app/components'
import { useModuleConfig } from '@webapp/app/config/useModuleConfig'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import {
  ContractCreatePage,
  ContractDetailsPage,
  ContractEditDetailsPage,
  ContractListPage,
} from '@webapp/pages'
import { ContractListPageStatuses } from '@webapp/pages/ContractListPage'

const contractStatusFormat = Object.values(ContractListPageStatuses).join('|')

const ContractRoute = ({ path, component, exact = false }: RouteProps) => {
  return (
    <ProtectedRoute
      exact={exact}
      path={path}
      component={component}
      navigationPermissions={['procure__contracts']}
    />
  )
}

export const ContractRouter = () => {
  const { url, brp } = useAppRoutes()

  const {
    routes: { enableContractRoutes },
  } = useModuleConfig()

  if (!enableContractRoutes) return <Redirect to={url('DashboardPage')} />

  return (
    <Switch>
      <Redirect
        exact
        from={brp('ContractListPage', {
          status: '',
        })}
        to={url('ContractListPage', {
          status: ContractListPageStatuses.ACTIVE,
        })}
      />

      <ContractRoute
        path={brp('ContractListPage', {
          status: `:status(${contractStatusFormat})`,
        })}
        component={ContractListPage}
      />

      <ContractRoute
        path={brp('ContractCreatePage', {
          uuid: ':uuid?',
        })}
        component={ContractCreatePage}
      />

      <ContractRoute
        exact
        path={brp('ContractDetailsPage', {
          uuid: ':uuid',
        })}
        component={ContractDetailsPage}
      />

      <ContractRoute
        path={brp('ContractEditDetailsPage', {
          uuid: ':uuid',
        })}
        component={ContractEditDetailsPage}
      />

      <Redirect to={url('DashboardPage')} />
    </Switch>
  )
}
